import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { TwoFactorEmailStartResponse } from 'core/models';
import { ApiBaseService } from './api.base.service';

@Injectable({
    providedIn: 'root',
})
export class ApiTwoFactorService extends ApiBaseService {
    constructor(http: HttpClient) {
        super(http, '/auth/2fa', null);
    }

    public startEmailCode(pendingToken: string): Observable<TwoFactorEmailStartResponse> {
        return this.post<TwoFactorEmailStartResponse>('/start', { pendingToken });
    }

    public resendEmailCode(pendingToken: string): Observable<TwoFactorEmailStartResponse> {
        return this.startEmailCode(pendingToken);
    }

    public getIdGovStartUrl(pendingToken: string, returnUrl: string, deepLink: string): string {
        const params = new HttpParams({
            fromObject: {
                pendingToken,
                returnUrl,
                deepLink,
            },
        });

        return `${this.fullUrl('/start')}?${params.toString()}`;
    }
}
